export enum FieldLadingExcel {
    LadingCode = 'ladingCode',
    OrderCode = 'orderCode',
    Username = 'username',
    LocationFromPhoneNumber = 'locationFrom.phoneNumber',
    LocationToName = 'locationTo.name',
    LocationToPhoneNumber = 'locationTo.phoneNumber',
    LocationToAddress = 'locationTo.address',
    LocationToProvince = 'locationTo.provinceId',
    LocationToDistrict = 'locationTo.districtId',
    LocationToWard = 'locationTo.wardId',
    BoxContent = 'boxContent',
    BoxQuantity = 'boxQuantity',
    BoxPrice = 'boxPrice',
    CodMoney = 'codMoney',
    Weight = 'weight',
    FreightService = 'freightServiceRowGuid',
    FreightServiceAdds = 'freightServiceAddRowGuids',
    Payment = 'payment',
    Note = 'note',
    Pickup = 'pickup',
    FeeExtra = 'feeExtra',
}
